export const bestSpecialSaleConfigurationsQuery = `
query BestSpecialSaleConfigurationsQuery($salesChannelId:ID!) {
  configurations(criteria: {salesChannels: [$salesChannelId]}, bestOnePer: [product, customerGroup]) {
    __typename
    id
    orderCode
    product {
      id
      title
      deeplinkId
    }
    customerGroup {
      id
      deeplinkId
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/products-api/queries/best-special-sale-configurations.js